import React, { useContext } from "react";
import { useMutation } from "react-query";

import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";

import * as api from "../../services";
import ActionButtonDialog from "../../Components/ActionButtonDialog";
import usePublicMoodboards from "./usePublicMoodboards";
import BoardsContext from "../boardsContext";
import AppContext from "../../appContext";
import useSaveSettings from "../../User/useSaveSettings";
import { logging } from "../../tools";

export default function ImportDialog({
  importDialog,
  setImportDialog,
  setImportedBoard,
}) {
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const { moodboardDispatch } = useContext(BoardsContext);
  // serevr
  const saveSettings = useSaveSettings();
  const saveLocalMoodboardMutation = useMutation((board) =>
    api.postLocalMoodboard({
      clientId,
      moodBoardJSON: JSON.stringify(board),
      projectId,
      sessionId,
    })
  );
  const importMoodboardMutation = useMutation(
    (moodboard) =>
      api.getPublicMoodboard({ id: moodboard.id, projectId, sessionId }),
    {
      onSuccess: (data, moodboard) => {
        if (data.data?.status > 0 && data.data?.moodBoard) {
          saveLocalMoodboardMutation.mutate(data.data.moodBoard); // server side: replace the current local moodboards
          setImportedBoard(moodboard);
          saveSettings.mutate({ moodBoardId: moodboard.id });
          moodboardDispatch({
            type: "SET_MOODBOARDS",
            payload: data.data.moodBoard,
          }); // replace the local moodboards
        }
      },
    }
  );
  // get moodboards
  const { publicMoodboards } = usePublicMoodboards();
  const handleClose = () => setImportDialog({ open: false });

  const buttons = publicMoodboards.map((moodboard) => ({
    id: moodboard.id,
    primaryText: `${moodboard.id}. ${moodboard.name}`,
    icon: <DashboardOutlinedIcon />,
    onClick: () => {
      logging(`Import moodboards with id: ${moodboard.id}`);
      importMoodboardMutation.mutate(moodboard);
      handleClose();
    },
  }));

  return (
    <ActionButtonDialog
      open={importDialog.open}
      setOpen={setImportDialog}
      dialogTitle="Import graphs from library"
      dialogContentText="Your current graphs will be overwritten."
      buttons={buttons}
    />
  );
}
